import { useStore } from '@/store';
import axios from '@axios';
import { getGlobalStickerAssetPath, getCustomStickerAssetPath } from '@/utils/config';
import { StickerType } from '@/utils/constants';

const getBitIcon = value => {
	const bits = Number(value);

	if (bits <= 999) {
		return require('@/assets/icons/bits/100.png');
	}
	if (bits > 999 && bits <= 4999) {
		return require('@/assets/icons/bits/1k.png');
	}
	if (bits > 4999 && bits <= 9999) {
		return require('@/assets/icons/bits/5k.png');
	}
	if (bits > 9999 && bits <= 99999) {
		return require('@/assets/icons/bits/10k.png');
	}
	if (bits > 99999) {
		return require('@/assets/icons/bits/10k.png');
	}

	return require('@/assets/icons/bits/100.png');
};

const getStickerImagePath = sticker => {
	const store = useStore();
	if (sticker.stickerType == StickerType.GLOBAL) {
		return getGlobalStickerAssetPath() + '/' + sticker.image;
	} else {
		return getCustomStickerAssetPath(store.state.channelId) + '/' + sticker.image;
	}
};

const logEvent = (eventType, eventBody) => {
	const payload = { eventType: eventType, eventBody: eventBody };
	axios.post('/user-event', payload).catch(err => {
		console.error(err);
	});
};

export { getBitIcon, getStickerImagePath, logEvent };
